module.exports = __webpack_public_path__ + "img/archana-pro.524cf584.jpg";